import './story-block.scss';

import { getParent } from '../../js/helper';

class StoryBlockSlider {
    constructor (element, options) {
        const defaults = {};

        this.settings = Object.assign({}, defaults, options);
        this.$storySlider = element;
    }

    initialize () {
        import('../../components/slider/slider').then(({ Slider }) => {
            let autoplay = false;

            if (this.$storySlider.getAttribute('autoplay') !== null) {
                autoplay = 5000;
            }

            const sliderAPI = new Slider(this.$storySlider, {
                autoplay: autoplay,
                effect: 'fade',
                speed: 500,
                indicators: true,
                slidesPerView: 1,
                slidesPerGroup: 1,
                initAttr: 'data-storyblock',
                onInit: () => {
                    const $rootBlock = getParent(this.$storySlider, '[data-storyblock="root"]');
                    $rootBlock.classList.add('has--slider');
                }
            });

            this.$storySlider.API = sliderAPI;
        });
    }
}

export { StoryBlockSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $storyBlockSliders = $context.querySelectorAll('[data-storyblock="slider"]');

        if ($storyBlockSliders.length > 0) {
            for (let i = 0; i < $storyBlockSliders.length; i++) {
                const $storyBlockSlider = new StoryBlockSlider($storyBlockSliders[i]);
                $storyBlockSlider.initialize();
            }
        }
    }
});
